export const RACKET_SPORTS = ['pickleball', 'paddle', 'badminton', 'lawn_tennis', 'table_tennis'];

export function isPlayEnabled(group) {
  if (!group) return false;
  const flag = group.play_settings?.enabled;
  if (flag === true || flag === false) return flag;
  return RACKET_SPORTS.includes(group.sport);
}

export function canScore(group, userId) {
  if (!group || !userId) return false;
  return (group.admin_ids || []).includes(userId) || (group.scorer_ids || []).includes(userId);
}

export function fmtDelta(d) {
  if (d === 0 || d == null) return '±0';
  return d > 0 ? `+${d}` : `${d}`;
}

export function deltaClass(d) {
  if (!d) return 'text-muted-foreground';
  return d > 0 ? 'text-emerald-600 dark:text-emerald-400' : 'text-rose-600 dark:text-rose-400';
}

export function firstName(name = '') {
  return String(name).split(' ')[0];
}

export function shareText(text) {
  if (navigator.share) return navigator.share({ text }).catch(() => {});
  window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank');
  return Promise.resolve();
}

export async function shareImage(url, filename, text) {
  const api = (await import('./api')).default;
  const r = await api.get(url.replace(/^\/api/, ''), { responseType: 'blob' });
  const type = r.headers?.['content-type'] || 'image/png';
  const file = new File([r.data], filename || (type.includes('pdf') ? 'card.pdf' : 'card.png'), { type });
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try { await navigator.share({ files: [file], text }); return 'shared'; } catch { return 'cancelled'; }
  }
  const a = document.createElement('a');
  a.href = URL.createObjectURL(r.data);
  a.download = file.name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  return 'downloaded';
}
